import StudentSignup from "./Pages/StudentSignup";
import ProfessorSignup from "./Pages/ProfessorSignup";
import CreateClass from "./Pages/CreateClass";
import AssignDefaultBook from "./Pages/Book";
import TeachMode from "./Pages/TeachMode";
import AuthGuard from "./guards/AuthGuard";
import ProfessorGuard from "./guards/ProfessorGuard";
import StudentGuard from "./guards/StudentGuard";
import TaGuard from "./guards/TaGuard";
import Home from "./Pages/Home";
import TAHome from "./Pages/TAHome";
import { TeacherAssistantInvite } from "./Pages/TeacherAssistantInvite";
import { TeacherAssistantSignup } from "./Pages/TeacherAssistantSignup";
import { TeacherAssistantSignIn } from "./Pages/TeacherAssistantSignIn";
import { StudentSection } from "./Pages/StudentSection";
import StudentBook from "./Pages/StudentBook";
import Dashboard from "./Pages/Dashboard";
import Activities from "./Pages/dashboard/Activities";
import Classes from "./Pages/dashboard/Classes";
import ClassDetails from "./Pages/dashboard/ClassDetails";
import GradeMode from "./Pages/dashboard/GradeMode";
import Profile from "./Pages/dashboard/Profile";
import StudentProfile from "./Pages/StudentDashboard/Profile";
import StudentSignnIn from "./Pages/StudentSignnIn";
import StudentClasses from "./Pages/StudentDashboard/StudentClasses";
import StudentActivities from "./Pages/StudentDashboard/StudentActivities";
import StudentSubject from "./Pages/StudentDashboard/StudentSubject";
import StudentOverview from "./Pages/StudentDashboard/StudentOverview";
import { StudentFocusedMode } from "./Pages/StudentFocusedMode";
import { CreateBook } from "./Pages/Book/CreateBook";
import { CreateNewBookPage } from "./Pages/Book/CreateNewBookPage";
import PickFromActivity from "./Pages/Book/PickFromActivity";
import UploadBookActivity from "./Pages/Book/UploadBookActivity";
import { AccessDenied } from "./Pages/AccessDenied";
import BookShelf from "./Pages/BookShelf";
import BookOverview from "./Pages/BookOverview";
import { ForgotPassword } from "./Pages/ForgotPassword";
import { ResetPassword } from "./Pages/ResetPassword";

export const routes = [{
        authGuard: true,
        path: "/home",
        component: AuthGuard(StudentGuard(Home)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/tahome",
        component: AuthGuard(TaGuard(TAHome)),
        exact: true,
    },
    {
        authGuard: false,
        path: "/",
        component: StudentSignnIn,
        exact: true,
    },
    {
        authGuard: false,
        path: "/studentSignup",
        component: StudentSignup,
        exact: true,
    },
    {
        authGuard: false,
        path: "/forgotPassword",
        component: ForgotPassword,
        exact: true,
    },
    {
        authGuard: false,
        path: "/resetPassword",
        component: ResetPassword,
        exact: true,
    },
    {
        authGuard: false,
        path: "/section/:joinCode",
        component: StudentSection,
        exact: true,
    },
    {
        authGuard: false,
        path: "/signup",
        component: ProfessorSignup,
        exact: true,
    },
    {
        authGuard: false,
        path: "/ta",
        component: TeacherAssistantInvite,
        exact: true,
    },
    {
        authGuard: false,
        path: "/teacherAssistantSignup",
        component: TeacherAssistantSignup,
        exact: true,
    },
    {
        authGuard: false,
        path: "/teacherAssistantSignin",
        component: TeacherAssistantSignIn,
        exact: true,
    },
    {
        authGuard: true,
        path: "/signup/createClass",
        component: AuthGuard(ProfessorGuard(CreateClass)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/defaultBook",
        component: ProfessorGuard(AssignDefaultBook),
        exact: true,
    },

    {
        authGuard: true,
        path: "/assign/:bookId",
        component: AuthGuard(ProfessorGuard(TeachMode)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/studentlearn",
        component: AuthGuard(StudentGuard(StudentBook)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/studentdashboard/overview",
        component: AuthGuard(StudentGuard(StudentOverview)),
        exact: true,
    },

    {
        authGuard: true,
        path: "/studentdashboard/classes",
        component: AuthGuard(StudentGuard(StudentClasses)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/studentdashboard/classes/class/:id",
        component: AuthGuard(StudentGuard(StudentSubject)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/studentdashboard/activities",
        component: AuthGuard(StudentGuard(StudentActivities)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/studentfocusedmode/:id",
        component: AuthGuard(StudentGuard(StudentFocusedMode)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/studentdashboard/settings",
        component: AuthGuard(StudentGuard(StudentProfile)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/dashboard",
        component: AuthGuard(ProfessorGuard(Dashboard)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/dashboard/bookshelf",
        component: AuthGuard(ProfessorGuard(BookShelf)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/dashboard/bookshelf/overview/:id",
        component: AuthGuard(ProfessorGuard(BookOverview)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/access-denied",
        component: AuthGuard(AccessDenied),
        exact: true,
    },
    {
        authGuard: true,
        path: "/dashboard/activities",
        component: AuthGuard(ProfessorGuard(Activities)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/dashboard/classes",
        component: AuthGuard(ProfessorGuard(Classes)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/dashboard/gradding/:answerId/:classId",
        component: AuthGuard(ProfessorGuard(GradeMode)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/dashboard/classes/:classId",
        component: AuthGuard(ProfessorGuard(ClassDetails)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/dashboard/settings",
        component: AuthGuard(ProfessorGuard(Profile)),
        exact: true,
    },

    /* Create mode */
    {
        authGuard: true,
        path: "/createbook",
        component: AuthGuard(ProfessorGuard(CreateBook)),
        exact: true,
    },

    {
        authGuard: true,
        path: "/create/pickfromlib",
        component: AuthGuard(ProfessorGuard(PickFromActivity)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/create/uploadbook",
        component: AuthGuard(ProfessorGuard(UploadBookActivity)),
        exact: true,
    },
    {
        authGuard: true,
        path: "/create/:bookId",
        component: AuthGuard(ProfessorGuard(CreateNewBookPage)),
        exact: true,
    },
];